"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const react_if_1 = require("react-if");
exports.TinySaveIndicator = ({ loading, error, success, buffer, errorString, leftIcon = false, }) => {
    // Buffer
    const [showBuffer, toggleBuffer] = react_use_1.useToggle(null);
    react_1.default.useEffect(() => {
        if (!showBuffer) {
            toggleBuffer(true);
        }
    }, [loading, success, error, errorString, showBuffer, toggleBuffer]);
    // Buffer
    react_use_1.useDebounce(() => {
        if (showBuffer) {
            const t = setTimeout(() => {
                toggleBuffer(false);
            }, buffer);
            return () => {
                clearTimeout(t);
            };
        }
        return () => { };
    }, 1.75 * 1000, [showBuffer]);
    // Icon
    const icon = errorString
        ? pro_solid_svg_icons_1.faExclamationCircle
        : loading
            ? pro_solid_svg_icons_1.faSpinnerThird
            : error
                ? pro_solid_svg_icons_1.faExclamationCircle
                : success
                    ? pro_solid_svg_icons_1.faCheckCircle
                    : null;
    const spinner = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, spin: loading, className: classnames_1.default(leftIcon ? 'mr-1' : 'ml-1', {
            'text-danger': !!(error || errorString),
            'text-muted': !!(loading && !errorString),
            'text-success': !!(success && !errorString),
        }) }));
    return (react_1.default.createElement(reactstrap_1.Fade, { in: !!errorString || showBuffer === null || showBuffer === true, mountOnEnter: false, unmountOnExit: false, enter: false },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_if_1.When, { condition: !!spinner && leftIcon }, spinner),
            errorString ||
                (loading
                    ? 'Saving...'
                    : error
                        ? 'Save failed'
                        : success
                            ? 'Saved'
                            : ''),
            react_1.default.createElement(react_if_1.When, { condition: !!spinner && !leftIcon }, spinner))));
};
//# sourceMappingURL=TinySaveIndicator.js.map